export enum Ethnicity {
  Malay = 1,
  Chinese = 2,
  Indian = 3,
  Others = 4,
}
